import { useSelector } from 'react-redux';

import { Feature } from 'dashboard/models/inquiry-template-version';
import { Organization } from 'dashboard/models/organization';
import { User } from 'dashboard/models/user';
import { RootState } from 'dashboard/redux/store';
import { SegmentClient } from 'lib/clients/SegmentClient';

const ENHANCED_LEARN_MORE_EVENT = 'Inquiries Enhanced - Learn More';
const SALES_CONTACT_US_LINK = '/dashboard/contact-us?category=sales';

// TODO(Collection-Editor) Consider merging this with useLearnMoreEventClick which has similar behavior
export default () => {
  const { currentUser, organization } = useSelector<
    RootState,
    { currentUser: User; organization: Organization }
  >((state) => {
    return {
      currentUser: state.currentUser?.currentUser,
      organization: state.organization?.organization,
    };
  });

  return ({ feature }: { feature: Feature }) => {
    SegmentClient.sendSegmentTrackEvent(ENHANCED_LEARN_MORE_EVENT, {
      feature,
      product: 'Inquiries',
      userId: currentUser?.id,
      organizationId: organization?.id,
    });

    window.open(SALES_CONTACT_US_LINK, '_blank');
  };
};
